import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { Row, Input } from 'react-materialize';
import './index.scss';
import services from '../../services/services';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class NewGtoType extends Component {

    constructor (props) {
        super(props);
        this.state = {
            socialName: localStorage.getItem("socialname"+this.props.data.numero_carteirinha),
            numeroCarteirinha: this.props.data.numero_carteirinha,
            alertCreatedGto : false,
            selectedGtoType : ''
        };
      }

    editGtoTypeChange(value){

        this.setState({
            gtoType: value            
        });

        this.props.editGtoType(value);
    }

    onTodoChangeSocialName(value){
      this.setState({
          socialName: value
      });

      localStorage.setItem("socialname"+this.state.numeroCarteirinha, value)
  }

    handleOkCriar = () => {
        this.setState({ alertCreatedGto: false });
      };

    render() {

      let textInput = React.createRef();
        return (
            <>
            <div className="NewProcedure12">
                <div className="NewProcedure12__infos row">
                <Row>
                    <form
                    className="col s12"
                    style={{
                        padding: '0px 0px 0px 0px',
                        marginBottom: '-35px',
                        backgroundColor: '#FFFFFF'
                    }}
                    onSubmit={e => e.preventDefault()}
                    >
                        <div className="dropdown-select" >
                          <label >
                            Tipo de Atendimento
                            <select
                            style={{ display: 'block', width:'100%', color:'rgb(27, 54, 93)' }}
                            onChange={e => this.editGtoTypeChange(e.target.value)}
                            
                            ref={textInput}
                            >
                              <option value={1}>1-Tratamento odontológico</option>
                              <option value={2}>2-Exame radiológico</option>
                              <option value={3}>3-Ortodontia</option>
                              <option value={4}>4-Urgência/Emergência</option>
                            </select>
                          </label>
                        </div>
                        <div style={{marginTop: '10%'}}>
                            <label>

                            Nome Social

                            </label>

                            <Input
                              className="txt-observacao"
                              id="input_social_name"
                              type="textarea"
                              label="Digite aqui o nome social"
                              onChange={e => this.onTodoChangeSocialName(e.target.value)}
                              value={this.state.socialName}
                              style={{fontSize: '13px', color: '#1b365d'}}
                              maxLength="70"
                              l={12}
                              m={12}
                              s={12}
                              xl={12}
                            />

                        </div>
                    </form>
                </Row>
                </div>
            </div>
        
        </>
        )

    }

}

export default NewGtoType;


